import React from 'react';

function Footer () {
    return (
        <div className="footer">
            <div className="footer-content">
                <div>
                    <span>&copy;2020 Ikatan Remaja Islam Nurul Falah</span>
                </div>
                <div>
                    <a href="https://instagram.com/irina_nilakandi" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                    <a href="https://bit.ly/YouTubeIRINA" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                </div>
            </div>
        </div>
    )
}

export default Footer